import { normalizeMediaUrl } from './normalizeMediaUrl';

const PREVIEW_FILE_PATTERN = /\.(pdf|jpe?g|png)($|\?|#)/i;

export function isImagePreviewUrl(url: string | null | undefined): boolean {
  if (!url) {
    return false;
  }
  return /\.(jpe?g|png)($|\?|#)/i.test(url);
}

export function isImagePreviewContent(html: string | null | undefined): boolean {
  if (!html) {
    return false;
  }
  const fileNameMatch = html.match(/Arquivo enviado pelo cidadão:\s*([^<\n]+)/i);
  if (fileNameMatch?.[1] && /\.(jpe?g|png)$/i.test(fileNameMatch[1].trim())) {
    return true;
  }
  return /<img[^>]*\ssrc=/i.test(html);
}

export function isPdfPreviewUrl(url: string | null | undefined): boolean {
  if (!url) {
    return false;
  }
  return /\.pdf($|\?|#)/i.test(url);
}

/** Extrai URL de arquivo embutida no HTML gerado pelo backend. */
export function extractFilePreviewUrl(
  html: string | undefined | null
): string | null {
  if (!html) {
    return null;
  }

  const iframeMatch = html.match(/<iframe[^>]*\ssrc=["']([^"']+)["']/i);
  if (iframeMatch?.[1]) {
    return normalizeMediaUrl(iframeMatch[1]);
  }

  const imageRegex = /<img[^>]*\ssrc=["']([^"']+)["']/gi;
  let imageMatch = imageRegex.exec(html);
  while (imageMatch) {
    const src = imageMatch[1];
    if (!/qrserver\.com/i.test(src)) {
      return normalizeMediaUrl(src);
    }
    imageMatch = imageRegex.exec(html);
  }

  const linkRegex = /<a[^>]+href=["']([^"']+)["'][^>]*>/gi;
  let linkMatch = linkRegex.exec(html);
  while (linkMatch) {
    const href = linkMatch[1];
    if (PREVIEW_FILE_PATTERN.test(href) || /\/uploads\//i.test(href)) {
      return normalizeMediaUrl(href);
    }
    linkMatch = linkRegex.exec(html);
  }

  const plainUrlMatch = html.match(
    /(https?:\/\/[^\s"'<>]+\.(?:pdf|jpe?g|png)[^\s"'<>]*)/i
  );
  if (plainUrlMatch?.[1]) {
    return normalizeMediaUrl(plainUrlMatch[1]);
  }

  return null;
}

export function buildGoogleGviewEmbedUrl(fileUrl: string): string {
  return `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`;
}

export function shouldUseLocalBlobPreview(fileUrl: string | null | undefined): boolean {
  if (!fileUrl) {
    return false;
  }
  return /localhost|127\.0\.0\.1/i.test(fileUrl);
}

export function isUploadedFileDocument(
  conteudo?: string | null,
  previewUrl?: string | null
): boolean {
  if (!conteudo) {
    return Boolean(previewUrl);
  }
  if (/Arquivo enviado pelo cidadão:/i.test(conteudo)) {
    return true;
  }
  if (/<iframe[^>]*\ssrc=/i.test(conteudo)) {
    return true;
  }
  return false;
}

export function shouldShowFileDocumentPreview(
  conteudo?: string | null,
  previewUrl?: string | null,
  options?: {
    origemTransmissao?: boolean;
    assinadoGovbrTramitacao?: boolean;
  },
): boolean {
  if (options?.origemTransmissao || options?.assinadoGovbrTramitacao) {
    return true;
  }
  if (previewUrl && (isPdfPreviewUrl(previewUrl) || isImagePreviewUrl(previewUrl))) {
    return true;
  }
  return (
    isUploadedFileDocument(conteudo, previewUrl)
    || Boolean(extractFilePreviewUrl(conteudo))
  );
}
